<template>
  <v-row>
    <v-col cols="12" md="4" >
      <v-radio-group v-model="value.tipo" row dense
        :rules="[
          this.$validators.string.required,
        ]">
        <v-radio
          label="Sintético"
          value="S"
        ></v-radio>
        <v-radio
          label="Analítico"
          value="A"
        ></v-radio>
      </v-radio-group>
    </v-col>    
    <v-col cols="12" md="4">
      <v-radio-group v-model="value.tipoInscricao" row 
        dense>
        <v-radio color="#efc00f"
          value="T">
          <template v-slot:label>
            Todos
          </template>
        </v-radio>
        <v-radio color="#efc00f"
          value="FOR">
          <template v-slot:label>
            Fornecedor
          </template>
        </v-radio>
        <v-radio color="#efc00f"
          value="COM">
          <template v-slot:label>
            Comprador
          </template>
        </v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" sm="4">
      <lookup-dominio label="Status"
        v-model="value.status"
        :type="lookups.status"
        :hidden-clear="false"/>
    </v-col>    
    <v-col cols="12">
        <v-text-field label="Empresa (comprador ou fornecedor)"
                      dense
                      v-model.trim="value.nomeEmpresa"/>
    </v-col>
    <v-col cols="12" sm="4">
      <search-box
          label="Tipo do Evento"
          popup-label="Selecione o Tipo do Evento"
          :id.sync="value.idEventoTipo"
          :descricao.sync="value.descEventoTipo"
          :value="eventoTipo"
          :loader-fn="loaderEventoTipo"
          item-key="id"
          item-text="descricao">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhuma EventoTipo encontrada
          </p>
        </template>
      </search-box>
    </v-col>  
    <v-col cols="12" sm="4">
      <search-box
          label="Evento"
          popup-label="Selecione um Evento"
          :id.sync="value.idEvento"
          :descricao.sync="value.descEvento"
          :value="evento"
          :loader-fn="loaderEvento"
          item-key="id"
          item-text="descricao">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhum Evento encontrado
          </p>
        </template>
      </search-box>
    </v-col>
    <v-col cols="12" sm="4">
      <search-box ref="comboEdicaoEventos"
          :hidden-clear="false"
          :emit-all-properties="true"
          label="Edição do Evento"
          popup-label="Selecione uma Edição Ativa"
          :id.sync="value.idEventoEdicao"
          :descricao.sync="value.descEventoEdicao"
          :value="eventoEdicao"
          :loader-fn="loaderEventoEdicao"
          item-key="id"
          item-text="descricao">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhuma Edição Ativa encontrada
          </p>
        </template>
      </search-box>
    </v-col>      
    <v-col cols="12">
      Período da Inscrição
      <v-spacer/>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field label="Data Inicio"
          dense
          type="date"
          clearable
          v-model="value.dtInicio"
          :rules="[
              v => this.$validators.string.lessThanOrEquals(v, 10)
          ]"/>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field label="Data Fim"
            dense
            type="date"
            clearable
            v-model="value.dtFim"
            :rules="[
                v => this.$validators.string.lessThanOrEquals(v, 10)
            ]"/>
    </v-col>     
  </v-row>
</template>

<script>

import OrderInput from "../../common/OrderInput";
import SearchBox from "../../common/SearchBox";
import {findAll as findAllEvento} from "../../../../api/evento";
import {findAll as findAllEventoTipo} from "../../../../api/eventoTipo";
import {findAll as findAllEventoEdicao} from "../../../../api/eventoEdicao";
import LookupDominio from "../../common/LookupDominio";
import {ItemDeDominio} from "../../../../api/itemsDominio";
import {mapGetters} from "vuex";

export default {
  name: "RelatorioInscricaoEventoForm",
  components: {
    SearchBox,
    OrderInput,
    LookupDominio
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      lookups: {
        status: ItemDeDominio.STATUS_INSCRICAO
      },      
    }
  },
  watch: {
    'value.idEvento': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.recarregaComboEventoEdicaoAtivas();
        }
      }
    },
    'value.idEventoTipo': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.recarregaComboEventoEdicaoAtivas();
        }
      }
    },
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
    evento() {
      if(this.value.idEvento == null) return null;
      return {
        id: this.value.idEvento,
        descricao: this.value.descEvento
      }
    },
    eventoTipo() {
      if(this.value.idEventoTipo == null) return null;
      return {
        id: this.value.idEventoTipo,
        descricao: this.value.descEventoTipo
      }
    },    
    eventoEdicao() {
      if(this.value.idEventoEdicao == null) return null;
      return {
        id: this.value.idEventoEdicao,
        descricao: this.value.descEventoEdicao
      }
    },    
  },
  methods: {
    recarregaComboEventoEdicaoAtivas() {
      this.$refs.comboEdicaoEventos.resetValues();
      this.$refs.comboEdicaoEventos.search();
    },    
    loaderEvento(page, search) {
      return findAllEvento(page, {
        descricao: search
      })
    },
    loaderEventoTipo(page, search) {
      return findAllEventoTipo(page, {
        descricao: search
      })
    },
    loaderEventoEdicao(page, search) {
      return findAllEventoEdicao(page, {
        descricao: search,
        idEvento: this.value.idEvento,
        idEventoTipo: this.value.idEventoTipo
      })
    },  
  }
}
</script>

<style scoped lang="scss">
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


</style>